import type { Position } from '@/voxelMath'

export type Axis = 'x' | 'y' | 'z'

export type DrawingSurface = {
  axis: Axis
  e: number
}

export type DrawingSurfaces = Record<string, DrawingSurface>

export const DEFAULT_DRAWING_SURFACE_ID = 'primary'

export function axisLength(bounds: Position, axis: Axis): number {
  return axis === 'x' ? bounds.x : axis === 'y' ? bounds.y : bounds.z
}

export function drawingSurfaceCoordinate(surface: DrawingSurface): number {
  return Math.floor(surface.e) + 1
}

export function isValidDrawingSurface(surface: DrawingSurface, bounds: Position): boolean {
  const len = axisLength(bounds, surface.axis)
  return Number.isFinite(surface.e) && surface.e >= 0 && surface.e <= len - 2
}
